import { RouteRecordRaw } from "vue-router"
import { routePaths } from "../routePaths"

const governRoutes: RouteRecordRaw[] = [
  {
    path: "/govern",
    name: "govern",
    component: () => import("@/layout/AbstractRouteView.vue"),
    meta: {
      isProtected: true
    },
    children: [
      {
        path: routePaths.govern.policy.path,
        name: routePaths.govern.policy.pathName,
        component: () => import("@/modules/govern/policies/pages/Policies.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "sideMenu.govern",
              translationKey: "sideMenu.govern",
              routeName: ""
            },
            {
              title: "sideMenu.myPolicies",
              translationKey: "sideMenu.myPolicies",
              routeName: ""
            }
          ]
        }
      },
      {
        path: routePaths.govern.consumedAgreements.path,
        name: routePaths.govern.consumedAgreements.pathName,
        component: () => import("@/modules/govern/agreements/pages/ConsumedAgreements.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "sideMenu.govern",
              translationKey: "sideMenu.govern",
              routeName: ""
            },
            {
              title: "sideMenu.consumedAgreements",
              translationKey: "sideMenu.consumedAgreements",
              routeName: ""
            }
          ]
        }
      },
      {
        path: routePaths.govern.providedAgreements.path,
        name: routePaths.govern.providedAgreements.pathName,
        component: () => import("@/modules/govern/agreements/pages/ProvidedAgreements.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "sideMenu.govern",
              translationKey: "sideMenu.govern",
              routeName: ""
            },
            {
              title: "sideMenu.providedAgreements",
              translationKey: "sideMenu.providedAgreements",
              routeName: ""
            }
          ]
        }
      }
    ]
  }
]

export default governRoutes
